import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import ImgBox from '@blade-sxp/tools/components/img-box.vue';
import Result from '@blade-sxp/tools/components/result.vue';
let CompareDetail = class CompareDetail extends Vue {
    folderImg = require('@blade-sxp/tools/assets/images/folder.svg');
    personImg = require('@blade-sxp/tools/assets/images/person.svg');
    visible = true;
    loading = false;
    source = {
        hasPre: true,
        hasNext: true,
        percent: '0',
        firstImage: {
            name: '',
            value: '',
            imageLib: ''
        },
        secoundImage: {
            name: '',
            value: '',
            imageLib: ''
        },
    };
    handleType;
    async handleBtn(type) {
        this.loading = true;
        try {
            this.source = await this.handleType(type);
            this.loading = false;
        }
        catch (e) {
            console.log(e);
            this.loading = false;
        }
    }
};
CompareDetail = __decorate([
    Component({
        name: 'compareDetail',
        components: { ImgBox, Result }
    })
], CompareDetail);
export default CompareDetail;
